import { Icon } from "~/components/icon";
import { formatBytes, formatNumber } from "~/utils";

interface OrgListItemProps {
  id: string;
  name: string;
  isByoc: boolean;
  href: string;
  customerId?: string | null;
  stats?: {
    namespaceCount: number;
    totalVectors: number;
    totalBytes: number;
  };
}

/** A linked org card: name, id, optional customer/stats line, BYOC/SaaS badge. */
export function OrgListItem({
  id,
  name,
  isByoc,
  href,
  customerId,
  stats,
}: OrgListItemProps) {
  return (
    <a
      href={href}
      className="flex items-center justify-between rounded-md border border-gray-200 bg-gray-100 px-3 py-2 transition-colors hover:bg-gray-200"
    >
      <div className="flex min-w-0 flex-col">
        <span className="truncate text-sm font-medium text-gray-900">
          {name}
        </span>
        <span className="truncate font-mono text-xs text-gray-500">{id}</span>
        {stats ? (
          <span className="text-xs text-gray-500">
            {stats.namespaceCount} ns | {formatNumber(stats.totalVectors)}{" "}
            vectors | {formatBytes(stats.totalBytes)}
          </span>
        ) : null}
      </div>
      <div className="ml-2 flex flex-shrink-0 items-center gap-2">
        {customerId ? (
          <span
            className="inline-flex items-center gap-1 rounded-full bg-amber-100 px-2 py-0.5 font-mono text-xs font-medium text-amber-700"
            title={`customer ${customerId}`}
          >
            <Icon name="Link" size={12} />
            {customerId}
          </span>
        ) : null}
        {isByoc ? (
          <span className="inline-flex items-center gap-1 rounded-full bg-blue-100 px-2 py-0.5 text-xs font-medium text-blue-700">
            BYOC
          </span>
        ) : (
          <span className="inline-flex items-center gap-1 rounded-full bg-green-100 px-2 py-0.5 text-xs font-medium text-green-700">
            SaaS
          </span>
        )}
        <Icon name="ChevronRight" size={14} className="text-gray-400" />
      </div>
    </a>
  );
}
